import { render } from "./AddGamePage.vue?vue&type=template&id=1cea01c5"
import script from "./AddGamePage.vue?vue&type=script&lang=js"
export * from "./AddGamePage.vue?vue&type=script&lang=js"

import "./AddGamePage.vue?vue&type=style&index=0&id=1cea01c5&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__